import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { t } from 'i18next';

import { LoadDigestLoadFilter } from '~hooks/useLoadDigests/models';
import isEnumValue from '~utils/isEnumValue';

const loadFilterLabelKeys = {
  [LoadDigestLoadFilter.ALL]: 'dispatch.load_digest.load_filters.all',
  [LoadDigestLoadFilter.COMPLETED]: 'dispatch.load_digest.load_filters.completed',
  [LoadDigestLoadFilter.APPROVED]: 'dispatch.load_digest.load_filters.approved',
} satisfies Record<LoadDigestLoadFilter, string>;

interface LoadDigestLoadFilterRadioGroupProps {
  isDisabled?: boolean;
  onChange: (loadFilter: LoadDigestLoadFilter) => void;
  value: LoadDigestLoadFilter;
}

export default function LoadDigestLoadFilterRadioGroup({
  isDisabled,
  onChange,
  value,
}: LoadDigestLoadFilterRadioGroupProps) {
  return (
    <RadioGroup
      aria-label={t('dispatch.load_digest.load_filter_label')}
      onChange={(event) => {
        if (isEnumValue(LoadDigestLoadFilter, event.target.value)) {
          onChange(event.target.value);
        }
      }}
      row
      value={value}
    >
      {Object.entries(loadFilterLabelKeys).map(([loadFilter, labelKey]) => (
        <FormControlLabel
          control={<Radio />}
          disabled={isDisabled}
          key={loadFilter}
          label={t(labelKey)}
          value={loadFilter}
        />
      ))}
    </RadioGroup>
  );
}
